import type { EvidenceTableContentProps } from '@/vantage/components/evidence_table/EvidenceTableContent';
import { EvidenceTableContent } from '@/vantage/components/evidence_table/EvidenceTableContent';

import { useEffect } from 'react';

export type VantageContentProps = {
  onContentLoad: () => void;
} & EvidenceTableContentProps;

/**
 * This component renders Vantage blobs in Organizer.
 */
export const VantageContent: React.FunctionComponent<VantageContentProps> = ({
  onContentLoad,
  contentId,
  roomName,
  viewName,
  quickFilter,
  tableId,
  tableColumns,
  tableData,
  evidenceContext,
  nonEvidenceContext,
  gridState,
  timezone,
}: VantageContentProps) => {
  // Only call onContentLoad once when the component mounts
  // eslint-disable-next-line react-compiler/react-compiler
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => onContentLoad(), []);

  return (
    <EvidenceTableContent
      data-cke-ignore-events="true"
      contentId={contentId}
      roomName={roomName}
      viewName={viewName}
      quickFilter={quickFilter}
      tableId={tableId}
      tableColumns={tableColumns}
      tableData={tableData}
      evidenceContext={evidenceContext}
      nonEvidenceContext={nonEvidenceContext}
      gridState={gridState}
      timezone={timezone}
    />
  );
};
